import React, { useEffect, useState } from 'react';
import { setPageSEO } from '../utils/seo.js';
import './FAQ.css';

const faqItems = [
  {
    id: 'faq01',
    question: 'How to add a video testimonial?',
    documentUrl: '/documentation/faqs/faq01/index.html'
  },
  {
    id: 'faq02',
    question: 'How can customers record a video testimonial?',
    documentUrl: '/documentation/faqs/faq02/index.html'
  },
  {
    id: 'faq03',
    question: 'How to create a testimonial widget?',
    documentUrl: '/documentation/faqs/faq03/index.html'
  },
  {
    id: 'faq04',
    question: 'How to create a Wall of Love?',
    documentUrl: '/documentation/faqs/faq04/index.html'
  },
  {
    id: 'faq05',
    question: 'How to create a testimonial template?',
    documentUrl: '/documentation/faqs/faq05/index.html'
  },
  {
    id: 'faq06',
    question: 'How to design a Wall of Love?',
    documentUrl: '/documentation/faqs/faq06/index.html'
  }
];

function FAQ() {
  const [openFaqId, setOpenFaqId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => setPageSEO({
    title: 'Frequently Asked Questions - Clientalio',
    description: "Find answers to common questions about onboarding, testimonials, integrations, pricing, and Clientalio's features.",
    canonical: 'https://clientalio.com/faq',
    ogTitle: 'Frequently Asked Questions - Clientalio',
    ogDescription: "Find answers to common questions about onboarding, testimonials, integrations, pricing, and Clientalio's features.",
    twitterTitle: 'Frequently Asked Questions - Clientalio',
    twitterDescription: "Find answers to common questions about onboarding, testimonials, integrations, pricing, and Clientalio's features."
  }), []);

  const filteredFaqItems = faqItems.filter((item) =>
    item.question.toLowerCase().includes(searchQuery.trim().toLowerCase())
  );

  return (
    <main className="faq-page">
      <section className="faq-library">
        <h1>FAQ Library</h1>
        <p className="faq-intro">Click a question to expand the answer directly below it.</p>

        <div className="faq-search">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-4-4" />
          </svg>
          <label className="faq-search-label" htmlFor="faq-search-input">Search FAQs</label>
          <input
            id="faq-search-input"
            type="search"
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            placeholder="Search how it works..."
          />
        </div>

        <div className="faq-list">
          {filteredFaqItems.map((item) => {
            const isOpen = openFaqId === item.id;

            return (
              <article className={`faq-item${isOpen ? ' is-open' : ''}`} key={item.id}>
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => setOpenFaqId(isOpen ? null : item.id)}
                  aria-expanded={isOpen}
                  aria-controls={`${item.id}-answer`}
                >
                  <span>{item.question}</span>
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m19 9-7 7-7-7" />
                  </svg>
                </button>

                {isOpen && (
                  <div className="faq-answer" id={`${item.id}-answer`}>
                    <iframe src={item.documentUrl} title={item.question} />
                  </div>
                )}
              </article>
            );
          })}

          {filteredFaqItems.length === 0 && (
            <p className="faq-empty">No FAQs found for “{searchQuery}”.</p>
          )}
        </div>
      </section>
    </main>
  );
}

export default FAQ;
